
export const getDescNameByLang = (fromObj, webLanguage) =>{
    switch(webLanguage){
        case 'English': 
            return fromObj['descInEnglish'];
        case 'Marathi': 
            return fromObj['descMr'];
        case 'Hindi': 
            return fromObj['descHin'];
        default:
            return fromObj['descInEnglish'];
    }
}

export const getMenuNameByLang = (fromObj, webLanguage) =>{
    switch(webLanguage){
        case 'English': 
            return fromObj['name']
        case 'Marathi': 
            return fromObj['nameMr']
        case 'Hindi': 
            return fromObj['nameHin']
        default:
            return fromObj['name']
    }
}

export const getLabelByLang = (fromObj, webLanguage) =>{

    switch(webLanguage){
        case 'English': 
            return fromObj['descInEnglish']
        case 'Marathi': 
            return fromObj['descInMarathi']
        case 'Hindi': 
            return fromObj['descInHindi']
        default:
            return fromObj['descInEnglish']
    }
}

export const getTableHeadNameByLang = (fromObj, webLanguage) =>{

    switch(webLanguage){
        case 'English': 
            return fromObj['displayName']
        case 'Marathi': 
            return fromObj['displayNameMr']
        case 'Hindi': 
            return fromObj['displayNameHin']
        default:
            return fromObj['displayName']
    }
}

export const getMenuPathByLang = (fromObj, webLanguage) =>{

    switch(webLanguage){
        case 'English': 
            return fromObj['menuFullPath']
        case 'Marathi': 
            return fromObj['menuFullPathInMarathi']
        case 'Hindi': 
            return fromObj['menuFullPathInHindi']
        default:
            return fromObj['menuFullPath']
    }
}

export const getStaticContentByLang = (fromObj, webLanguage) =>{

    switch(webLanguage){
        case 'English': 
            return fromObj['htmlContent']
        case 'Marathi': 
            return fromObj['htmlContentMr']
        case 'Hindi': 
            return fromObj['htmlContentHin']
        default:
            return fromObj['htmlContent']
    }
}

export const getOfficeBearerDesignationByLang = (fromObj=[], webLanguage) =>{

    function sortEngObj(obj) {
        return Object.keys(obj)
        .sort()
        .reduce(function (result, key) {
            result[key] = obj[key];
            return result;
        }, {});
    }
    function sortOhterObj(obj) {
        return Object.keys(obj)
        .reduce(function (result, key) {
            result[key] = obj[key];
            return result;
        }, {});
    }
    switch(webLanguage){
        case 'English': 
            // return fromObj['officeBearer']
            return sortEngObj(fromObj['officeBearer'])
        case 'Marathi': 
            // return fromObj['officeBearerInMarathi'] ? fromObj['officeBearerInMarathi']: fromObj['officeBearer']
            let mrObject = fromObj['officeBearerInMarathi'] ? fromObj['officeBearerInMarathi']: fromObj['officeBearer']
            return sortOhterObj(mrObject)
        case 'Hindi': 
            // return fromObj['officeBearerInHindi'] ? fromObj['officeBearerInHindi']: fromObj['officeBearer']
            let hnObject = fromObj['officeBearerInHindi'] ? fromObj['officeBearerInHindi']: fromObj['officeBearer']
            return sortOhterObj(hnObject)

        default:
            return fromObj['officeBearer']
    }
}
export const getChairmanMessageByLang = (fromObj=[], webLanguage) =>{
    switch(webLanguage){
        case 'English': 
            return fromObj['chairmanMessage']
        case 'Marathi': 
            return fromObj['chairmanMessageInMarathi'] ? fromObj['chairmanMessageInMarathi']: fromObj['chairmanMessage']
        case 'Hindi': 
            return fromObj['chairmanMessageInHindi'] ? fromObj['chairmanMessageInHindi']: fromObj['chairmanMessage']
        default:
            return fromObj['htmlContent']
    }
}

export const getOfficeBearerNameByLang = (fromObj, webLanguage) =>{
    switch(webLanguage){
        case 'English': 
            return fromObj['name'] !== null ? fromObj['name'] : '-'
        case 'Marathi': 

            return fromObj['nameMr'] !== null ? fromObj['nameMr'] : '-'
        case 'Hindi': 
            return fromObj['nameHin'] !== null ? fromObj['nameHin'] : '-'
        default:
            return fromObj['name'] !== null ? fromObj['name'] : '-'
    }
}
export const getOfficeBearerEduQualificationByLang = (fromObj, webLanguage) =>{
    switch(webLanguage){
        case 'English': 
            return fromObj['educationalQualification']
        case 'Marathi': 
            return fromObj['educationalQualificationMr']
        case 'Hindi': 
            return fromObj['educationalQualificationHin']
        default:

            return fromObj['educationalQualification']
    }
}